import styled from 'styled-components';

const PerfectLocationStyle = styled.section`
	--distanceBlock: var(--sp4x);
	--lottieLeftDistance: var(--sp12x);
	--distanceTitleDescription: var(--sp6x);
	--padRightWrap: var(--sp37x);
	--padLeftWrap: var(--sp12x);
	--radiusImage: var(--sp3x);
	--centerImageWidth: 58%;
	--rightImageSize: 27.7vw;
	--leftImageSize: 30vw;
	--centerImageSize: 18.3vw;
	--centerImageMR: var(--sp15x);
	--distanceDescriptionLottie: var(--sp6x);
	--distanceImageLottie: var(--sp4x);

	--lottieWidth: var(--sp48x);
	--lottieHeight: var(--sp26x);

	padding: var(--sectionDistance) var(--contPaddingLR);
	overflow: hidden;

	.title-wrap {
		padding-bottom: var(--distanceTitleDescription);
	}

	.outside-wrapper {
		display: grid;
		grid-template-columns: 640fr 1206fr 600fr;
		column-gap: var(--distanceBlock);
	}

	.wrap-outside-image {
		width: 100%;
		height: fit-content;
	}

	.image-cont {
		display: flex;
		border-radius: var(--radiusImage);

		img {
			border-radius: var(--radiusImage);
		}
	}

	.left-wrap {
		grid-area: 1/1/3/2;
		padding-bottom: var(--padLeftWrap);

		.image-cont {
			--proportion: var(--leftImageSize);
		}
	}

	.info-wrap {
		grid-area: 1/2/2/3;

		.title-wrap,
		.description-wrap {
			display: flex;
			align-items: center;
			justify-content: center;
		}

		.editor-wrapper {
			max-width: calc(100% * 4 / 6);
		}
	}

	.right-wrap {
		grid-area: 1/3/3/4;

		padding-bottom: var(--padRightWrap);

		.image-cont {
			--proportion: var(--rightImageSize);
		}
	}

	.center-wrap {
		grid-area: 2/2/3/3;
		display: flex;
		flex-direction: column;
		align-items: flex-end;

		.lottie-outside-wrap {
			width: 100%;
			padding-left: calc(var(--lottieLeftDistance) - var(--distanceBlock));
			padding-top: var(--distanceDescriptionLottie);
			padding-bottom: var(--distanceImageLottie);

			.lottie-wrap {
				width: var(--lottieWidth) !important;
				height: var(--lottieHeight) !important;

				display: flex;
				align-items: center;

				svg {
					height: auto !important;
				}
			}
		}

		.wrap-outside-image {
			width: var(--centerImageWidth);
			margin-right: var(--centerImageMR);
		}

		.image-cont {
			--proportion: var(--centerImageSize);
		}
	}
	.left-wrap {
		.wrap-outside-image {
			transform: translateY(100%);
		}
	}

	.right-wrap,
	.center-wrap {
		.wrap-outside-image {
			transform: translateY(100%);
		}
	}

	.left-wrap,
	.right-wrap {
		display: flex;
		align-items: flex-end;
	}

	.wrapper-styling-block {
		text-align: center;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceBlock: var(--sp4x);
		--lottieLeftDistance: var(--sp8x);
		--distanceTitleDescription: var(--sp4x);
		--padRightWrap: var(--sp31x);
		--padLeftWrap: var(--sp12x);
		--radiusImage: var(--sp3x);
		--centerImageWidth: 54%;
		--rightImageSize: 27.2vw;
		--leftImageSize: 28vw;
		--centerImageSize: 16.7vw;
		--centerImageMR: var(--sp15x);
		--distanceDescriptionLottie: var(--sp3x);
		--distanceImageLottie: var(--sp2-5x);

		--lottieWidth: var(--sp35x);
		--lottieHeight: var(--sp19x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceBlock: var(--sp3x);
		--lottieLeftDistance: var(--sp7x);
		--distanceTitleDescription: var(--sp4x);
		--padRightWrap: var(--sp26x);
		--padLeftWrap: var(--sp8x);
		--radiusImage: var(--sp2x);
		--centerImageWidth: 54%;
		--rightImageSize: 27.2vw;
		--leftImageSize: 29.6vw;
		--centerImageSize: 16.7vw;
		--centerImageMR: var(--sp12x);
		--distanceDescriptionLottie: var(--sp3x);
		--distanceImageLottie: var(--sp3x);

		--lottieWidth: var(--sp28x);
		--lottieHeight: var(--sp15x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--distanceBlock: var(--sp3x);
		--lottieLeftDistance: var(--sp8x);
		--distanceTitleDescription: var(--sp3x);
		--padRightWrap: var(--sp25x);
		--padLeftWrap: var(--sp8x);
		--radiusImage: var(--sp2x);
		--centerImageWidth: 54%;
		--rightImageSize: 27vw;
		--leftImageSize: 27.6vw;
		--centerImageSize: 16.7vw;
		--centerImageMR: var(--sp11x);
		--distanceDescriptionLottie: var(--sp4x);
		--distanceImageLottie: var(--sp3x);

		--lottieWidth: var(--sp25x);
		--lottieHeight: var(--sp14x);

		.outside-wrapper {
			grid-template-columns: 3fr 6fr 3fr;
		}
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--distanceBlock: var(--sp3x);
		--lottieLeftDistance: var(--sp8x);
		--distanceTitleDescription: var(--sp2-5x);
		--padRightWrap: var(--sp25x);
		--padLeftWrap: var(--sp11x);
		--radiusImage: var(--sp1-5x);
		--centerImageWidth: 54%;
		--rightImageSize: 27vw;
		--leftImageSize: 27.6vw;
		--centerImageSize: 16.7vw;
		--centerImageMR: var(--sp10x);
		--distanceDescriptionLottie: var(--sp4x);
		--distanceImageLottie: var(--sp4x);

		--lottieWidth: var(--sp24x);
		--lottieHeight: var(--sp13x);
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceBlock: var(--sp2-5x);
		--lottieLeftDistance: var(--sp6x);
		--distanceTitleDescription: var(--sp2x);
		--padRightWrap: var(--sp22x);
		--padLeftWrap: var(--sp6x);
		--radiusImage: var(--sp1-5x);
		--centerImageWidth: 54%;
		--rightImageSize: 26.3vw;
		--leftImageSize: 29vw;
		--centerImageSize: 16.5vw;
		--centerImageMR: var(--sp8x);
		--distanceDescriptionLottie: var(--sp4x);
		--distanceImageLottie: var(--sp3x);

		--lottieWidth: var(--sp18x);
		--lottieHeight: var(--sp9x);

		.info-wrap {
			.editor-wrapper {
				max-width: 100%;
			}
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--distanceBlock: var(--sp2x);
		--lottieLeftDistance: var(--sp4x);
		--distanceTitleDescription: var(--sp2x);
		--padRightWrap: var(--sp26x);
		--padLeftWrap: var(--sp10x);
		--radiusImage: var(--sp1x);
		--centerImageWidth: 54%;
		--rightImageSize: 26.3vw;
		--leftImageSize: 28vw;
		--centerImageSize: 16.5vw;
		--centerImageMR: var(--sp4x);
		--distanceDescriptionLottie: var(--sp6x);
		--distanceImageLottie: var(--sp2x);

		--lottieWidth: var(--sp13x);
		--lottieHeight: var(--sp7x);

		.outside-wrapper {
			grid-template-columns: 3fr 6fr 3fr;
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceBlock: var(--sp2-5x);
		--distanceTitleDescription: var(--sp2x);
		--padRightWrap: 0px;
		--padLeftWrap: 0px;
		--centerImageMR: 0px;

		--radiusImage: var(--sp1x);
		--centerImageWidth: 49%;
		--rightImageSize: 47.3vw;
		--leftImageSize: 57vw;
		--centerImageSize: 30.5vw;

		--distanceDescriptionLottie: 0;
		--distanceImageLottie: 0;

		--lottieWidth: var(--sp13x);
		--lottieHeight: var(--sp7x);

		.center-wrap {
			align-items: center;
			position: relative;
			padding-top: var(--sp7x);

			.lottie-outside-wrap {
				position: absolute;
				right: 0;
				top: 0;
				width: fit-content;
				padding: 0;
				transform: translateY(-50%) translateX(-8vw);
			}
		}

		.outside-wrapper {
			grid-template-columns: 175fr 149fr;
		}

		.info-wrap {
			grid-area: 1/1/2/3;
		}

		.left-wrap {
			grid-area: 2/1/3/2;
			padding-top: var(--sp6x);
		}

		.right-wrap {
			align-items: flex-start;
			grid-area: 2/2/3/3;
		}

		.center-wrap {
			grid-area: 3/1/4/3;
		}

		.description-wrap {
			padding-bottom: var(--sp4x);
		}
	}
`;

export default PerfectLocationStyle;
